import { ButtonProps, Button as MuiButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const Button = styled(MuiButton)<ButtonProps>(({ theme }) => ({
  textTransform: "none",
  borderRadius: 8,
  height: 56,
  fontSize: 18,
  gap: 4,
  paddingLeft: 32,
  paddingRight: 32,
  fontWeight: 700,
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
  },
}));

export default Button;
